import Icon from './Icon';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'

export default ({ error = "" }) => {
    return(
        <p className="text-danger">{ error && <Icon icon={faTriangleExclamation} className="me-2" />}{ error }</p>
    )
}